import { CampaignRequirementResponse } from "types/campaign/requirement";

export const handleInfluencerLocationData = (campaignRequirements: CampaignRequirementResponse) : CampaignRequirementResponse => {
    let updatedCampaignRequirements = {...campaignRequirements};
    updatedCampaignRequirements.requirement = {...updatedCampaignRequirements.requirement || {}}
    updatedCampaignRequirements.requirement.details = {...updatedCampaignRequirements.requirement.details || {}};

    const cities = updatedCampaignRequirements.requirement?.details?.cities;
    const regions = updatedCampaignRequirements.requirement?.details?.regions;

    if ((!Array.isArray(cities) || cities.length === 0) && (!Array.isArray(regions) || regions.length === 0)) {
        updatedCampaignRequirements.requirement.details.cities = null;
        updatedCampaignRequirements.requirement.details.regions = [];
    } else if (!Array.isArray(cities) || cities.length === 0) {
        updatedCampaignRequirements.requirement.details.cities = null;
    } else if (!Array.isArray(regions) || regions.length === 0) {
        updatedCampaignRequirements.requirement.details.regions = null;
    }

    return updatedCampaignRequirements;
}